import { render } from "./Coffee.vue?vue&type=template&id=55eafe86"
import script from "./Coffee.vue?vue&type=script&lang=js"
export * from "./Coffee.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__